import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import commonNetwork from "../../common/api/commonNetwork";
import { FetchResultType } from "../fetchTypes";

type getTenantInformationProp={
    firmname?: string 
}
type Props = {
    parameters: getTenantInformationProp
}
export const getTenantInformation = createAsyncThunk(
  "/tenant/get",
  async ({parameters}: Props, { rejectWithValue }) => {
    try {
      // authToken eklenecek cookie,local vs biryerden okunup
      const { data, errorMessage, isSuccess } = await commonNetwork.get("/tenant/"+parameters.firmname);
      if (isSuccess ) {
        return data;
      } else {
        return rejectWithValue(data);
      }
    } catch (e:any) {
      return rejectWithValue(e.data.message);
    }
  }
);
 
export type TenantFirmType={
firmName: string,
firmPath: string,
firmCode: string,
logoPath?:string,
isPublicPayment?:boolean,
licenseKey: string,
taxCode: string,
email?:string,
web?:string
}

export interface tenantStateType  extends FetchResultType{
    firmInformations:TenantFirmType,
    isfirmAvailable : boolean
}
export const tenantSlice = createSlice({
  name: "tenant",
  initialState: {
    firmInformations: {},
    isfirmAvailable: true,
    isFetching: true,
    isSuccess: false,
    isError: false,
    errorMessage: "",
  },
  reducers: {
    clearState: (state) => {
      state.firmInformations = {};
      state.isFetching = false;
      state.isSuccess = false;
      state.isError = false;
      state.isfirmAvailable = true;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getTenantInformation.fulfilled, (state, { payload }) => {
      state.firmInformations = payload;
      state.isFetching = false;
      state.isSuccess = true;
      state.isError = false;
      state.isfirmAvailable = true;
      return state;
    });
    builder.addCase(getTenantInformation.rejected, (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.firmInformations = {};
      state.isfirmAvailable = false; 
    });
    builder.addCase(getTenantInformation.pending, (state) => {
      state.isFetching = true;
      state.isfirmAvailable = true;
    });
  },
});
export const { clearState } = tenantSlice.actions;

export const tenantSelector = (state:any) => state.tenant;

export const tenantReducer = tenantSlice.reducer;
